import(/* webpackMode: "eager" */ "/vercel/path0/src/app/preferences/page.js");
